import React, {Fragment} from 'react';
import Tabs from 'react-responsive-tabs';
import Provincia from './component/provincia';
import PageTitle from '../../../../Layout/AppMain/PageTitle';



export default class ProvinciaComponent extends React.Component {

    render() {

        return (
         <Provincia></Provincia>
        )
    }
}


// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Provincia/index.js